import * as Types from '../graphql/hirer-types.generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type YourCandidatesQueryVariables = Types.Exact<{
  input: Types.YourCandidatesInput;
}>;

export type YourCandidatesQuery = {
  __typename: 'Query';
  yourCandidates:
    | {
        __typename: 'YourCandidatesPayloadError';
        error: Types.YourCandidatesPayloadErrorType;
      }
    | {
        __typename: 'YourCandidatesResults';
        totalCount: number;
        totalPages: number;
        edges: Array<{
          __typename: 'YourCandidateEdge';
          node: {
            __typename: 'YourCandidate';
            name: string;
            phoneNumber?: string | null;
            lastRoleCompanyName?: string | null;
            lastRoleJobTitle?: string | null;
            status: Types.YourCandidateStatus;
            prospectId: number;
            jobId: string;
            channel: Types.YourCandidateChannel;
            totalApplications: number;
            jobTitle: string;
            hasResume: boolean;
            hasCoverLetter: boolean;
            hasSelectionCriteria: boolean;
            adcentreCandidateId: number;
            candidateId: number;
            applicationTime: string;
          };
        }>;
      };
};

export type YourCandidatesNode_CandidateRowFragment = {
  __typename: 'YourCandidate';
  name: string;
  phoneNumber?: string | null;
  lastRoleCompanyName?: string | null;
  lastRoleJobTitle?: string | null;
  status: Types.YourCandidateStatus;
  prospectId: number;
  jobId: string;
  channel: Types.YourCandidateChannel;
  totalApplications: number;
  jobTitle: string;
  hasResume: boolean;
  hasCoverLetter: boolean;
  hasSelectionCriteria: boolean;
  adcentreCandidateId: number;
  candidateId: number;
  applicationTime: string;
};

export type ApplicationAttachmentsQueryVariables = Types.Exact<{
  input: Types.ApplicationAttachmentInput;
}>;

export type ApplicationAttachmentsQuery = {
  __typename: 'Query';
  applicationAttachments: {
    __typename: 'ApplicationAttachments';
    nodes: Array<{
      __typename: 'ApplicationAttachment';
      typeName: string;
      filename?: string | null;
      uploadedDate?: any | null;
      isPdf: boolean;
      id: string;
      type: number;
      uploadedUser?: string | null;
    }>;
  };
};

export const YourCandidatesNode_CandidateRowFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YourCandidatesNode_CandidateRow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'YourCandidate' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRoleCompanyName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastRoleJobTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalApplications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasResume' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCoverLetter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasSelectionCriteria' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adcentreCandidateId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationTime' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const YourCandidatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'YourCandidates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YourCandidatesInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'yourCandidates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'YourCandidatesResults' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'YourCandidatesNode_CandidateRow',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'YourCandidatesPayloadError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YourCandidatesNode_CandidateRow' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'YourCandidate' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRoleCompanyName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastRoleJobTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'prospectId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalApplications' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasResume' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCoverLetter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasSelectionCriteria' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adcentreCandidateId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'candidateId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationTime' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useYourCandidatesQuery__
 *
 * To run a query within a React component, call `useYourCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useYourCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYourCandidatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useYourCandidatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    YourCandidatesQuery,
    YourCandidatesQueryVariables
  > &
    (
      | { variables: YourCandidatesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<YourCandidatesQuery, YourCandidatesQueryVariables>(
    YourCandidatesDocument,
    options,
  );
}
export function useYourCandidatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    YourCandidatesQuery,
    YourCandidatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<YourCandidatesQuery, YourCandidatesQueryVariables>(
    YourCandidatesDocument,
    options,
  );
}
export function useYourCandidatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    YourCandidatesQuery,
    YourCandidatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    YourCandidatesQuery,
    YourCandidatesQueryVariables
  >(YourCandidatesDocument, options);
}
export type YourCandidatesQueryHookResult = ReturnType<
  typeof useYourCandidatesQuery
>;
export type YourCandidatesLazyQueryHookResult = ReturnType<
  typeof useYourCandidatesLazyQuery
>;
export type YourCandidatesSuspenseQueryHookResult = ReturnType<
  typeof useYourCandidatesSuspenseQuery
>;
export type YourCandidatesQueryResult = Apollo.QueryResult<
  YourCandidatesQuery,
  YourCandidatesQueryVariables
>;
export const ApplicationAttachmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicationAttachments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ApplicationAttachmentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationAttachments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'typeName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filename' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uploadedDate' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPdf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uploadedUser' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useApplicationAttachmentsQuery__
 *
 * To run a query within a React component, call `useApplicationAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationAttachmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplicationAttachmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ApplicationAttachmentsQuery,
    ApplicationAttachmentsQueryVariables
  > &
    (
      | { variables: ApplicationAttachmentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ApplicationAttachmentsQuery,
    ApplicationAttachmentsQueryVariables
  >(ApplicationAttachmentsDocument, options);
}
export function useApplicationAttachmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApplicationAttachmentsQuery,
    ApplicationAttachmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ApplicationAttachmentsQuery,
    ApplicationAttachmentsQueryVariables
  >(ApplicationAttachmentsDocument, options);
}
export function useApplicationAttachmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ApplicationAttachmentsQuery,
    ApplicationAttachmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ApplicationAttachmentsQuery,
    ApplicationAttachmentsQueryVariables
  >(ApplicationAttachmentsDocument, options);
}
export type ApplicationAttachmentsQueryHookResult = ReturnType<
  typeof useApplicationAttachmentsQuery
>;
export type ApplicationAttachmentsLazyQueryHookResult = ReturnType<
  typeof useApplicationAttachmentsLazyQuery
>;
export type ApplicationAttachmentsSuspenseQueryHookResult = ReturnType<
  typeof useApplicationAttachmentsSuspenseQuery
>;
export type ApplicationAttachmentsQueryResult = Apollo.QueryResult<
  ApplicationAttachmentsQuery,
  ApplicationAttachmentsQueryVariables
>;
